import React, { Component } from "react";
import { styles } from "../styles";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
} from "@material-ui/core";
import ExcelImportErrors from "../components/ExcelImportErrors";

class ShowComponent extends Component {
  state = {
    isOpenExcelErrors: false,
  };

  render() {
    const handleOpen = () => {
      this.setState({ isOpenExcelErrors: true });
    };
    const handleClose = () => {
      this.setState({ isOpenExcelErrors: false });
    };

    return (
      <div>
        {this.props.record.wrongExcelImportHistory.length > 0 && (
          <Button style={styles.chip} onClick={handleOpen}>
            Show
          </Button>
        )}
        {this.state.isOpenExcelErrors && (
          <Dialog open maxWidth={false}>
            <DialogContent>
              <ExcelImportErrors {...this.props} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    );
  }
}

export default ShowComponent;



// WEBPACK FOOTER //
// ./src/companies/ShowComponent.js